import { copApi } from 'api'

export interface Props {
  practitionerId: string
  userIds: string[]
}

export const patchWhitelistedUsers = ({ practitionerId, userIds }: Props) =>
  copApi.patch<Props>(`/practitioners/${practitionerId}/visibility-whitelist`, {
    userIds: userIds || [],
  })
